import { useEffect, useState, useCallback } from "react";
import { Scanner as QrScanner } from "@yudiel/react-qr-scanner";

import { Box, Divider, Text, Input, HStack, Button } from "@chakra-ui/react";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

interface AddViewQrReaderProps {
  deviceAddress: string;
  setDeviceAddress: (value: string) => void;
  onScanned: (scannedAddress: string) => void;
  onCancel: () => void;
}

const AddViewQrReader: React.FC<AddViewQrReaderProps> = ({
  deviceAddress,
  setDeviceAddress,
  onScanned,
  onCancel,
}) => {
  const [scanResult, setScanResult] = useState<string>("");

  useEffect(() => {
    if (scanResult) {
      onScanned(scanResult);
    }
  }, [scanResult]);

  const handleApply = () => {
    onScanned(deviceAddress);
  };

  return (
    <>
      <Box
        bg="gray.100"
        borderRadius="3px"
        h="350px"
        w="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        overflow="hidden"
        marginTop={9}
      >
        <QrScanner
          onScan={(codes: any[]) => {
            if (!codes || !codes.length) return;
            const code = codes[0].rawValue || "";
            if (code && /^[a-zA-Z0-9]*$/.test(code)) {
              setScanResult(code);
            }
          }}
          onError={() => {
            console.log("Error occurred while scanning.");
          }}
          constraints={{ facingMode: "environment" }}
          scanDelay={200}
          sound={true}
          styles={{
            container: { width: "100%", height: "100%" },
            video: { width: "100%", height: "100%", objectFit: "cover" },
          }}
        />
      </Box>

      <Divider my={4} />

      <Text fontSize="md" color="gray.600" mb={2}>
        <Trans>Or enter Code:</Trans>
      </Text>
      <Input
        fontFamily="mono"
        fontSize="md"
        placeholder={t`123456789abcdef`}
        value={deviceAddress}
        onChange={(e) => setDeviceAddress(e.target.value)}
        border="none"
        borderBottom="1px solid"
        borderColor="gray.300"
        borderRadius={0}
        _placeholder={{ color: "gray.400" }}
      />

      <Divider my={4} />
      <Box position="relative" zIndex={10}>
        <HStack spacing={4} mt={4}>
          <Button flex={1} onClick={onCancel} variant="outline">
            <Trans>Back</Trans>
          </Button>
          <Button flex={1} onClick={handleApply} colorScheme="teal">
            <Trans>Next</Trans>
          </Button>
        </HStack>
      </Box>
    </>
  );
};

export default AddViewQrReader;
